import React, { Children } from 'react';
import styled from 'styled-components';
import { useLayoutContext } from './layout';
import { media } from '../../hooks/use-responsive-v2.hook';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledHeader = styled.header.withConfig({
  displayName: "layoutHeader__StyledHeader",
  componentId: "sc-op2eni-0"
})(["height:", ";min-height:", ";display:flex;align-items:center;justify-content:space-between;gap:16px;background:#ffffff;border-bottom:1px solid rgba(0,0,0,0.06);padding:0 24px;position:sticky;top:0;z-index:100;", "{height:60px;min-height:60px;padding:0 16px;}"], function (props) {
  return props.$height;
}, function (props) {
  return props.$height;
}, media.mobile);
var LogoWrapper = styled.div.withConfig({
  displayName: "layoutHeader__LogoWrapper",
  componentId: "sc-op2eni-1"
})(["display:flex;align-items:center;font-size:20px;font-weight:600;color:#1890ff;cursor:pointer;transition:opacity 0.3s;&:hover{opacity:0.8;}"]);
var LeftSection = styled.div.withConfig({
  displayName: "layoutHeader__LeftSection",
  componentId: "sc-op2eni-2"
})(["display:flex;align-items:center;gap:16px;"]);
var DefaultLogo = styled.div.withConfig({
  displayName: "layoutHeader__DefaultLogo",
  componentId: "sc-op2eni-3"
})(["display:flex;align-items:center;font-size:20px;font-weight:600;color:#1890ff;"]);
export var LayoutHeader = function LayoutHeader(_ref) {
  var logo = _ref.logo,
      onMenuClick = _ref.onMenuClick,
      children = _ref.children,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '60px' : _ref$height;

  var _useLayoutContext = useLayoutContext(),
      hasIcon = _useLayoutContext.hasIcon;

  var shouldShowMenuButton = false;
  var childArray = Children.toArray(children);
  var logoFromChildren = childArray.length >= 2 ? childArray[0] : undefined;
  var headerContent = childArray.length >= 2 ? childArray.slice(1) : childArray;
  var logoContent = logo !== null && logo !== void 0 ? logo : logoFromChildren;

  var defaultLogo = /*#__PURE__*/_jsx(DefaultLogo, {
    children: /*#__PURE__*/_jsx("img", {
      src: "/icons/digi-logo.svg",
      alt: "logo",
      style: {
        height: '30px'
      }
    })
  });

  return /*#__PURE__*/_jsx(StyledHeader, {
    $height: height,
    children: logo ? children : headerContent
  });
};
LayoutHeader.displayName = 'LayoutHeader';